import { useEffect } from "react";

// Injects one or more JSON-LD structured-data blocks into <head>,
// and cleans them up on unmount so SPA navigation stays correct.
export default function StructuredData({ id, data }) {
  useEffect(() => {
    const nodes = (Array.isArray(data) ? data : [data]).map((obj, i) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.setAttribute("data-ld", `${id}-${i}`);
      el.text = JSON.stringify(obj);
      document.head.appendChild(el);
      return el;
    });
    return () => nodes.forEach((n) => n.remove());
  }, [id, data]);
  return null;
}
